const unit = () => {
    const unitBtn = document.querySelectorAll('[data-id]');
    const unitItem = document.querySelectorAll('[data-tab="item"]');

    unitBtn.forEach((btn) => {
        btn.addEventListener('click', () => {
            const targetId = btn.dataset.id;

            unitBtn.forEach((b) => b.classList.remove('is-active'));
            unitItem.forEach((item) => item.classList.remove('is-active'));
            btn.classList.add('is-active');

            const targetTab = document.getElementById(targetId);
            if (targetTab) {
                targetTab.classList.add('is-active');
            }
        });
    });
};
export default unit;
